import Component from 'gia/Component'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);



class  Showroom extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)
    this.index = 0
    this.progress = 0

    this.ref = {
      page: [],
      img: [],
      bg: ""
    }
  }

  mount() {

    // const step = this.ref.page.length
    // const pas = (1 / step);

    gsap.fromTo(
        this.ref.bg, {
            ease: 'none',
            yPercent: 14.28
        }, {
            scrollTrigger: {
                trigger: this.element,
                start: "top top",
                end: "bottom bottom",
                scrub: true,
                onUpdate: (self) => {

                }
            },
            ease: 'none',
            yPercent: -14.28
        }
    )


     this.ref.page.forEach((item, i) => {
       var img = item.getAttribute('img');


       let trigger = ScrollTrigger.create({
         trigger: item,
         start: 'top bottom',
         end: 'top top',
         markers: false,
         onEnter: (self) => {
          //  gsap.to(this.ref.bg, {
          //    backgroundColor: colr,
          //    duration: 1.2
          //  });
          $('.showroom__image--visible').removeClass('showroom__image--visible')
          this.ref.img[i].classList.add('showroom__image--visible')
         },
         onEnterBack: (self) => {
           //  gsap.to(this.ref.bg, {
           //    backgroundColor: colr,
           //    duration: 1.2
           //  });
           $('.showroom__image--visible').removeClass('showroom__image--visible')
           this.ref.img[i].classList.add('showroom__image--visible')
         }
       });

       return () => {
         
         if (trigger.isActive) {
          $('.showroom__image--visible').removeClass('showroom__image--visible')
          this.ref.img[i].classList.add('showroom__image--visible')
         }
       }

     });
  
  }

  changeImg() {

  
  }


  unmount() {

  }


}

module.exports = Showroom
